import { z } from "zod"

// Version 1 ---------------------
export const DividingHeaderSettingsV1 = z.object({
  title: z.string(),
})

export type TDividingHeaderSettingsV1 = z.infer<typeof DividingHeaderSettingsV1>

export const DividingHeaderElementV1 = z.object({
  id: z.string(),
  name: z.literal("dividingHeader"),
  settings: DividingHeaderSettingsV1,
})

export type TDividingHeaderElementV1 = z.infer<typeof DividingHeaderElementV1>

// Latest ---------------------
export const DividingHeaderSettings = DividingHeaderSettingsV1
export type TDividingHeaderSettings = TDividingHeaderSettingsV1
export const DividingHeaderElement = DividingHeaderElementV1
export type TDividingHeaderElement = TDividingHeaderElementV1
